import styled from 'styled-components';
import { Help } from 'ui/icons/action/Help';
import { Body2 } from 'ui/theme/typography/components';
import { spacing, colors } from 'ui/theme';
import { BodyDisabled, Card, constructFlexSpacing } from '../Styles';

export const CampaignsCard = styled(Card)`
  display: flex;
  flex-direction: column;
`;

export const CampaignsDividerText = styled(Body2)`
  color: ${colors.textSecondary};
  margin-bottom: ${spacing.threeQuarter};
`;

export const CampaignsHistoryContainer = styled.div`
  margin-bottom: ${spacing.threeQuarter};
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${spacing.threeQuarter};
`;

export const HelpIcon = styled(Help)`
  color: ${colors.textSecondary};
`;

export const CampaignsDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${spacing.base};
`;

export const AlignedDisabledText = styled(BodyDisabled)`
  text-align: center;
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
`;

export const CampaignImg = styled.img`
  border: ${`${spacing.single} solid ${colors.grey15}`};
  border-radius: ${spacing.quarter};
  margin-right: ${spacing.threeQuarter};
`;

export const CampaignTextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CampaignDateContainer = styled.div`
  ${constructFlexSpacing(spacing.quarter)};
  align-items: center;
`;
